<template>
  <span class="svg-ico-frown">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.99827 9.84255C8.5464 9.84255 8.18009 10.2089 8.18009 10.6607C8.18009 11.1126 8.5464 11.4789 8.99827 11.4789H9.01034C9.46221 11.4789 9.82852 11.1126 9.82852 10.6607C9.82852 10.2089 9.46221 9.84255 9.01034 9.84255H8.99827Z" :fill="color"/>
      <path d="M14.5437 10.6607C14.5437 10.2089 14.91 9.84255 15.3619 9.84255H15.374C15.8258 9.84255 16.1921 10.2089 16.1921 10.6607C16.1921 11.1126 15.8258 11.4789 15.374 11.4789H15.3619C14.91 11.4789 14.5437 11.1126 14.5437 10.6607Z" :fill="color"/>
      <path d="M10.1125 16.7936C11.2473 15.6371 13.1128 15.6371 14.2476 16.7936C14.5641 17.1162 15.0821 17.1211 15.4046 16.8046C15.7271 16.4881 15.732 15.9701 15.4156 15.6475C13.6393 13.8373 10.7208 13.8373 8.94455 15.6475C8.62807 15.9701 8.63297 16.4881 8.9555 16.8046C9.27803 17.1211 9.79605 17.1162 10.1125 16.7936Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5437 12.7788C22.5437 4.80987 13.9059 -0.166335 6.99868 3.81565C3.79225 5.66407 1.81641 9.08068 1.81641 12.7788C1.81641 20.7477 10.4541 25.7239 17.3614 21.7419C20.5678 19.8934 22.5437 16.4768 22.5437 12.7788ZM7.81595 5.23331C13.636 1.87811 20.9073 6.07329 20.9073 12.7788C20.9073 15.891 19.2445 18.7675 16.5441 20.3242C10.7241 23.6794 3.45277 19.4842 3.45277 12.7788C3.45277 9.66647 5.11564 6.78997 7.81595 5.23331Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
